import { render, staticRenderFns } from "./Holding.vue?vue&type=template&id=17448f2c&"
import script from "./Holding.vue?vue&type=script&lang=js&"
export * from "./Holding.vue?vue&type=script&lang=js&"
import style0 from "./Holding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VNavigationDrawer,VTextField})
